import {
  ImageScaleView,
  View,
  ViewOpts,
  animate,
} from '@play-co/timestep-core/ui';

export class Match2BundleSaleArrow extends View {
  public readonly arrow: ImageScaleView;

  constructor(opts: ViewOpts) {
    super({
      width: 258,
      height: 272,
      centerOnOrigin: true,
      ...opts,
    });

    this.arrow = new ImageScaleView({
      superview: this,
      width: 220,
      height: 60,
      image: 'assets/ui/match2/bundlesale/bundlesale_arrow.png',
      scaleMethod: 'stretch',
      centerOnOrigin: true,
      anchorX: 0.5,
      anchorY: 0.5,
      zIndex: -1,
      opacity: 0,
    });
  }

  public updateArrow(pointsTo: { x: number; y: number }) {
    const angle = Math.atan2(
      pointsTo.y - this.style.y,
      pointsTo.x - this.style.x,
    );
    const halfWidth = this.style.width * 0.5;
    const halfHeight = this.style.height * 0.5;
    this.arrow.updateOpts({
      r: angle,
      x: halfWidth + Math.cos(angle) * (halfWidth + 24),
      y: halfHeight + Math.sin(angle) * (halfHeight + 12),
    });
  }

  public async animateShow() {
    await animate(this.arrow)
      .now({ opacity: 1 }, 200, animate.linear)
      .toPromise();
  }

  public async animateHide() {
    await animate(this.arrow)
      .now({ opacity: 0 }, 200, animate.linear)
      .toPromise();
  }
}
